export const GET_SAVED_REPORTS = 'GET_SAVED_REPORTS';
export const GET_SAVED_REPORTS_SUCCESS = 'GET_SAVED_REPORTS_SUCCESS';
export const GET_SAVED_REPORTS_FAILURE = 'GET_SAVED_REPORTS_FAILURE';

export const SAVE_REPORT = 'SAVE_REPORT';
export const SAVE_REPORT_SUCCESS = 'SAVE_REPORT_SUCCESS';
export const SAVE_REPORT_FAILURE = 'SAVE_REPORT_FAILURE';

export const DELETE_SAVED_REPORT = 'DELETE_SAVED_REPORT';
export const DELETE_SAVED_REPORT_SUCCESS = 'DELETE_SAVED_REPORT_SUCCESS';
export const DELETE_SAVED_REPORT_FAILURE = 'DELETE_SAVED_REPORT_FAILURE';
